module.exports = __webpack_public_path__ + "static/media/storage_get_open_tips.f232a91.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/CESite40s/mp3/storage_get_open_tips.mp3
// module id = d5YQ
// module chunks = 1